// extracted by mini-css-extract-plugin
export default {"link":"MyButton_link__XC-1w"};